import { CheckDataType } from './CheckDataType';

// 数字分割
export const toThousands = (num, segmentation = 3) => {
    num = (num || 0).toString();

    const reg = new RegExp(`(\\d{1,${segmentation}})(?=(\\d{${segmentation}})+(?:$|\\.))`, 'g');

    // var re = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
    return num.replace(reg, '$1,');
};

export const formatNumber = (num, options) => {
    const finalDisplay = new Intl.NumberFormat('en-US', {
        // 1. 小数位数（千分位最常用）
        minimumFractionDigits: 0, // 最少显示2位小数（不足补0）
        maximumFractionDigits: 2, // 最多显示4位小数（超过则四舍五入）
        ...options,
        // 2. 整数位数（可选）
        // minimumIntegerDigits: 1, // 最少显示1位整数（默认1）
        // 3. 舍入模式（可选，ES2020+支持）
        // roundingMode: "halfUp", // 四舍五入（默认值，其他值：halfDown/ceil/floor等）
        // 4. 样式扩展（可选，比如货币/百分比）
        // style: 'currency',      // 货币格式（需配合currency使用）
        // currency: 'USD',        // 货币类型（USD/CNY等）
        // style: 'percent',       // 百分比格式
    }).format(Number(num));

    // const finalDisplay = new Intl.NumberFormat("en-US", {
    //     minimumFractionDigits: 6, //保留6位小数
    //     maximumFractionDigits: 6, //保留6位小数
    // }).format(Number(formattedEth));

    return finalDisplay;
};

// 数字分割包含判断是否是数字和默认值
export const numToThousands = (num, defaultSymbol = '---') => {
    return CheckDataType.isStringNumber(num) || CheckDataType.isNumber(num) ? toThousands(num) : defaultSymbol;
};

// 保留两位小数
export const reserveFloor = (num) => Math.round(num * 100) / 100;

export const transformUnit = (num, decimalPlace = 2) => {
    let code = '1';
    for (let i = 0; i < decimalPlace; i++) {
        code += '0';
    }

    const decimalPlaceNumber = new Function(`${code}`)();

    // 亿
    // 万
    // 千
    if (num / 100000000 / 10000 >= 1) {
        return reserveFloor(num / 100000000 / 10000) + '万亿';
    }
    // else if (num / 10000000 / 1000 >= 1) {
    //   return reserveFloor(num / 10000000 / 1000) + '千亿';
    // } else if (num / 10000000 / 100 >= 1) {
    //   return reserveFloor(num / 10000000 / 100) + '百亿';
    // } else if (num / 10000000 / 10 >= 1) {
    //   return reserveFloor(num / 10000000 / 10) + '十亿';
    // }
    else if (num / 100000000 >= 1) {
        return reserveFloor(num / 100000000, decimalPlaceNumber) + '亿';
    } else if (num / 10000 >= 1) {
        return reserveFloor(num / 10000, decimalPlaceNumber) + '万';
    }

    return num;
};

export const transformSearchParams = (data) => {
    let $data = {};

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            if (CheckDataType.isArray(data[key])) {
                $data = {
                    ...$data,
                    [key]: { $in: data[key] },
                };
            } else {
                $data = {
                    ...$data,
                    [key]: data[key],
                };
            }
        }
    }

    return $data;
    // gpu_area: { $in: ['美国', '新加坡'] }, // 多选
    // company_name: { $regex: company_name, $options: 'i' }, // 模糊
    // cpu_model: 'GTX 1080',  //
};

// 单位是分钟
export const convertMinutesToHoursDay = (totalMinutes) => {
    // 处理非数字/负数（可选，根据业务需求调整）

    const totalHours = Math.floor(totalMinutes / 60); // 取整得到小时

    const days = Math.floor(totalHours / 24); // 天数

    const hours = totalHours % 24; // 剩余小时数
    const minutes = totalMinutes % 60; // 取余得到剩余分钟
    return { hours, minutes, days };
};

// 单位是秒
// 数字补零：小于10前面加0，返回字符串
const padZero = (num) => String(num).padStart(2, '0');

export const convertSecondsToDayHours = (totalSeconds) => {
    // 1. 处理非法值（非数字/负数，返回0）
    if (typeof totalSeconds !== 'number' || totalSeconds < 0) {
        return { days: 0, hours: '00', minutes: '00', seconds: '00' };
    }

    // 2. 核心：秒 → 分钟
    const totalMinutes = Math.floor(totalSeconds / 60);
    // 剩余的秒数（不足1分钟的部分）
    const rawSeconds = totalSeconds % 60;

    // 3. 原逻辑不变：分钟 → 天、小时、分钟
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const rawHours = totalHours % 24;
    const rawMinutes = totalMinutes % 60;

    // 4. 全部补零格式化输出
    return {
        days, // 天数保留数字，如需两位字符串改为 padZero(days)
        hours: padZero(rawHours),
        minutes: padZero(rawMinutes),
        seconds: padZero(Math.floor(rawSeconds)), // 秒向下取整后补0
    };
};
